import type {CssVarsThemeOptions} from "@mui/material/styles";
import UIUtils from "../utils";

/**
 * The default theme of the application.
 */
const theme: CssVarsThemeOptions = {
    cssVarPrefix: UIUtils.ThemePrefix,
    components: {
        MuiContainer: {
            defaultProps: {
                maxWidth: 'xl',
            },
            styleOverrides: {
                root: {
                    '@media (min-width: 600px)': {
                        paddingLeft: '48px',
                        paddingRight: '48px',
                    },
                },
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                size: 'medium',
            },
            styleOverrides: {
                root: {
                    borderRadius: '25px',
                },
                notchedOutline: ({theme}) => ({
                    borderColor: 'rgba(89, 53, 138, 1)',
                }),
            },
        },
        MuiToolbar: {
            styleOverrides: {
                root: {
                    paddingRight: `0px !important`,
                    paddingLeft: `0px !important`,
                },

            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: 'rgba(89, 53, 138, 0.5)',
                    fontWeight: 700,
                },
            },
        },
    },
};


export default theme;

